// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartConfigSuspensionTireLink } from './part-config-suspension-tire-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigSuspension extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  _tireSizes: any[] = [];
    // get tireSizes(): any[] {
    //       return this.partConfigSuspensionTireLinks?.map((x) => { return {id: x.id, tireId: x.partConfigTire?.id, name: x.partConfigTire?.name} }) || [];
    //   }

    get tiresHtml(): string {
        return this._tireSizes.map((x) => x.name).join('<br/>');
    }
    setSuspensionTireLinks(links: PartConfigSuspensionTireLink[], tires: any[]) {
        this._tireSizes = links.filter((x) => !x.deleted).map((x) => ({ id: x.id, tireId: x.partConfigTire?.id, name: x.partConfigTire?.name }));
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
  value?: string;
  partConfigSuspensionTireLinks!: PartConfigSuspensionTireLink[];
}

